import {Component, OnInit} from '@angular/core';
import {FormGroup, FormControl} from '@angular/forms';
import {ApiService} from '../../../../service/api.service';
import {TranslateService} from '@ngx-translate/core';
import {NotificationsService, NotificationType} from 'angular2-notifications';
import {Router, ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-conversion',
  templateUrl: './conversion.component.html',
  styleUrls: ['./conversion.component.css']
})
export class ConversionComponent implements OnInit {
  loading = false;
  applicationForm: FormGroup;
  pageLangId: any;
  entList: any;
  kaztestList: any;
  subjList: any[] = [];
  convertDataList: any;
  totalScore: any;
  isConvert: any;
  fullDate = '00-00-0000';
  iin = '000000000000';
  phone = '+0 (000) 000-00-00';
  selected: boolean;
  openWindow = false;
  openConvert = false;
  selectedEntTestId: number | null = null;
  selectedKazTestId: number | null = null;
  selectedKazTestLevelId: number | null = null;
  levelId: number | null = null;

  constructor(
    public api: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private _notifications: NotificationsService,
    public translate: TranslateService,
  ) {
  }

  ngOnInit(): void {
    if (localStorage.getItem('Lang') == 'ru') {
      this.pageLangId = 2;
    } else {
      this.pageLangId = 1;
    }
    this.applicationForm = new FormGroup({
      lastname: new FormControl({value: '', disabled: true}),
      firstname: new FormControl({value: '', disabled: true}),
      patronymic: new FormControl({value: '', disabled: true}),
      email: new FormControl({value: '', disabled: true}),
      iin: new FormControl({value: '', disabled: true}),
      phoneNumber: new FormControl(),
    });
    this.getProfileData();
  }

  getProfileData() {
    this.api.profileInfo()
      .subscribe((res: any) => {
        this.applicationForm.get('iin').setValue(res.data.iin);
        this.applicationForm.get('firstname').setValue(res.data.firstname);
        this.applicationForm.get('lastname').setValue(res.data.lastname);
        this.applicationForm.get('patronymic').setValue(res.data.patronymic);
        this.applicationForm.get('email').setValue(res.data.email);
        this.applicationForm.get('phoneNumber').setValue(res.data.phoneNumber);
        this.getEntItem();
        this.getKaztestItem();
      }, (err: any) => {
      });
  }

  getEntItem() {
    this.api.getEntItems()
      .subscribe((res: any) => {
        this.entList = res.items;
      });
  }

  getKaztestItem() {
    this.api.getKaztestItems()
      .subscribe((res: any) => {
        this.kaztestList = res.items;
      });
  }

  onEntSelectionChange(selectedItem: any): void {
    this.entList.forEach(item => item.selected = false);
    selectedItem.selected = true;
    this.selectedEntTestId = selectedItem.studentTestId;
    this.subjList = [];
  }

  onKaztestSelectionChange(selectedItem: any): void {
    this.kaztestList.forEach(item => item.selected = false);
    selectedItem.selected = true;
    this.selectedKazTestId = selectedItem.studentTestId;
    this.selectedKazTestLevelId = selectedItem.levelId;
    this.subjList = [];
  }

  checkCon(): void {
    let data = {
      entStudentTestId: this.selectedEntTestId,
      kazTestStudentTestId: this.selectedKazTestId,
      kazTestLevelId: this.selectedKazTestLevelId,
    };
    this.api.checkConvert(data)
      .subscribe((res: any) => {
        this.subjList = res.data.subjects;
        this.totalScore = res.data.totalScore;
      },
        (err: any) => {
          this.loading = false;
          this.translate.currentLang == 'ru' ? this._notifications.create('Ошибка', err.error.errorMessage.ru, NotificationType.Error,
            5000) : this._notifications.create('Қате', err.error.errorMessage.kk, NotificationType.Error, 5000);
        });
  }

  convert(): void {
    if (this.selectedEntTestId && this.selectedKazTestId) {
      let data = {
        entStudentTestId: this.selectedEntTestId,
        kazTestStudentTestId: this.selectedKazTestId,
      };
      this.api.convertation(data)
        .subscribe((res: any) => {
          this.convertDataList = res.data;
          this.openConvert = false;
          this.translate.currentLang == 'ru' ? this._notifications.create('Успешно', 'Сертификат успешно сконвертирован, нажмите кнопку "Скачать файл"',
            NotificationType.Success,
            5000) : this._notifications.create('Сәтті', 'Сертификат сәтті конвертацияланды, "Файлды жүктеу" батырмасын басыңыз',
            NotificationType.Success, 5000);
        });
    }
  }

  getIsConverted(){
    if (!this.selectedEntTestId && !this.selectedKazTestId || this.selectedEntTestId && !this.selectedKazTestId || !this.selectedEntTestId
      && this.selectedKazTestId) {
      this.translate.currentLang == 'ru' ? this._notifications.create('Ошибка', 'Не выбраны сертификаты', NotificationType.Error,
          5000)
        : this._notifications.create('Қате', 'Сертификаттар таңдалмады', NotificationType.Error, 5000);
    }
    this.api.convertIsconverted(this.selectedEntTestId, this.selectedKazTestId)
      .subscribe((res: any) => {
        this.isConvert = res;
        if (this.isConvert.isConverted == false) {
          this.checkCon();
        } else {
          this.openWindow = true;
        }
      });
  }

  download() {
    this.loading = true;
    this.api.downloadCertificate(this.convertDataList.studentTestId, this.convertDataList.iin, this.convertDataList.testYear, 1)
      .subscribe((res: any) => {
        window.location.href = res.data.certificateDownLoadUrl;
        this.loading = false;
      });
  }

  closeModal(){
    this.openWindow = false;
  }

  closeModalConvert(){
    this.openConvert = false;
  }
}
